import { Injectable } from '@angular/core';
import { DictionaryStr } from '@hrra/core';

@Injectable({
  providedIn: 'root'
})
export class TranslitService {
  private readonly generalMap: DictionaryStr<string> = {
    // Georgian, with apostrophes omitted for slugs.
    'ა': 'a',  'ბ': 'b',  'გ': 'g',  'დ': 'd',  'ე': 'e',  'ვ': 'v',
    'ზ': 'z',  'თ': 't',  'ი': 'i',  'კ': 'k',  'ლ': 'l',  'მ': 'm',
    'ნ': 'n',  'ო': 'o',  'პ': 'p',  'ჟ': 'zh', 'რ': 'r',  'ს': 's',
    'ტ': 't',  'უ': 'u',  'ფ': 'p',  'ქ': 'k',  'ღ': 'gh', 'ყ': 'q',
    'შ': 'sh', 'ჩ': 'ch', 'ც': 'ts', 'ძ': 'dz', 'წ': 'ts', 'ჭ': 'ch',
    'ხ': 'kh', 'ჯ': 'j',  'ჰ': 'h',

    // Cyrillic letters shared by Russian and Kazakh.
    'а': 'a',  'б': 'b',  'в': 'v',    'г': 'g', 'д': 'd',  'е': 'e',
    'ё': 'yo', 'ж': 'zh', 'з': 'z',    'и': 'i', 'й': 'y',  'к': 'k',
    'л': 'l',  'м': 'm',  'н': 'n',    'о': 'o', 'п': 'p',  'р': 'r',
    'с': 's',  'т': 't',  'у': 'u',    'ф': 'f', 'х': 'kh', 'ц': 'ts',
    'ч': 'ch', 'ш': 'sh', 'щ': 'shch', 'ъ': '',  'ы': 'y',  'ь': '',
    'э': 'e',  'ю': 'yu', 'я': 'ya',

    // Additional Kazakh Cyrillic letters.
    'ә': 'a', 'ғ': 'gh', 'қ': 'q', 'ң': 'ng', 'ө': 'o',
    'ұ': 'u', 'ү': 'u',  'һ': 'h', 'і': 'i',

    // Armenian, including the two-letter spellings matched in getString().
    'ա': 'a',  'բ': 'b',  'գ': 'g',  'դ': 'd',  'ե': 'e',  'զ': 'z',
    'է': 'e',  'ը': 'y',  'թ': 't',  'ժ': 'zh', 'ի': 'i',  'լ': 'l',
    'խ': 'kh', 'ծ': 'ts', 'կ': 'k',  'հ': 'h',  'ձ': 'dz', 'ղ': 'gh',
    'ճ': 'ch', 'մ': 'm',  'յ': 'y',  'ն': 'n',  'շ': 'sh', 'ո': 'o',
    'չ': 'ch', 'պ': 'p',  'ջ': 'j',  'ռ': 'rr', 'ս': 's',  'վ': 'v',
    'տ': 't',  'ր': 'r',  'ց': 'ts', 'ւ': 'w',  'փ': 'p',  'ք': 'k',
    'օ': 'o',  'ֆ': 'f',  'և': 'ev', 'ու': 'u', 'եւ': 'ev',

    // Azerbaijani Latin. ASCII I in English text passes through getString().
    'ç': 'ch', 'ə': 'e', 'ğ': 'g', 'İ': 'i', 'ı': 'i',
    'ö': 'o',  'ş': 'sh', 'ü': 'u',
  };

  public getString(original: string): string {
    return original.normalize('NFC').replace(/ու|եւ|./giu, (key) =>
      this.generalMap[key] ?? this.generalMap[key.toLowerCase()] ?? key
    );
  }

  public getUrlFriendlyString(original: string): string {
    return this.getString(original)
      .toLowerCase()
      .normalize('NFD')
      .replace(/\p{M}+/gu, '')
      .replace(/['’]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }
}